// eslint-disable-next-line
export function onClickImageButton() {
  document.querySelector('#editor-image-input').click();
}
